import fetchAPI from '../../fetchAPI';
import { useQuery } from '@tanstack/react-query';

type Props = {
  locationId?: string;
  startDate?: string | null;
  endDate?: string | null;
};

export const useCoreDashboard = ({ locationId, startDate, endDate }: Props) => {
  const query = new URLSearchParams();

  if (locationId) {
    query.append('locationId', locationId);
  }
  if (startDate) {
    query.append('startDate', startDate);
  }
  if (endDate) {
    query.append('endDate', endDate);
  }

  return useQuery({
    queryKey: [`core/dashboard-numbers`, locationId, startDate, endDate],
    queryFn: async () => {
      const response = await fetchAPI<{ data: CoreDashboardNumbers }>({
        method: 'GET',
        route: `core/dashboard-numbers`,
        queryString: query.toString()
      });

      return response;
    },
    enabled: !!startDate && !!endDate // Query will only run if type is provided
  });
};

export default useCoreDashboard;
